/* eslint-disable no-unused-vars */
import React from 'react';
import PropTypes from 'prop-types';

/**
 * Custom toggle component required by react-bootstrap Dropdown component.
 * Will display children as-is and ignore the toggle functionality.
 * @param {*} props - props
 * @param {*} ref - Imperative handle to component that will toggle the dropdown's open state.
 * @returns {ReactNode} Foo
 */
export const CustomDropdownToggle = React.forwardRef((props, ref) => (
  <React.Fragment>{props.children}</React.Fragment>
));

CustomDropdownToggle.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
};
